import React, { useState } from 'react';
import DynamicWorldMap from './DynamicWorldMap';
import Legend from './Legend';
import ShipmentDetails from './ShipmentDetails'; // Import the new component
import { useMyContext } from "../../../context/MyContext";
import { useConnectionData } from './ConnectionData'; // Import connection data hook

const WorldMap = ({ data }) => {
  const { user, preloadedCountries } = useMyContext();
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const { connectionData, loading, error } = useConnectionData(user || {});

  // Use preloaded for globe, processed for chart
  const countries = preloadedCountries;

  return (
    <div>
      <div className="relative">
        <DynamicWorldMap
          isUser={user.role === "user"}
          data={data}
          countries={countries} // For 3D globe
          hoveredCountry={hoveredCountry} // Pass for name overlay
          setHoveredCountry={setHoveredCountry}
        />
        {user.role === "user" && (
          <Legend />
        )}
        {user.role === "user" && (
          <ShipmentDetails
            hoveredCountry={hoveredCountry}
            connectionData={connectionData}
          />
        )}
      </div>
    </div>
  );
};

export default WorldMap;